import { render, staticRenderFns } from "./TagSet.vue?vue&type=template&id=a153fb10&scoped=true&"
import script from "./TagSet.vue?vue&type=script&lang=js&"
export * from "./TagSet.vue?vue&type=script&lang=js&"
import style0 from "./TagSet.vue?vue&type=style&index=0&id=a153fb10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a153fb10",
  null
  
)

export default component.exports